<template>
  <div id="tabbar">
    <!--使用keep-alive会将页面缓存-->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <div class="bottomBar">
      <ul>
        <router-link :to="{name:'index',query: { supNbr:userInfo.nbr }}">
          <li @click="toColor">
            <p><img :src="isColor?require('../assets/images/icon_home1@2x.png'):require('../assets/images/icon_home2@2x.png')" alt=""></p>
            <p :class="{bottomBarColorActive:isColor}">首页</p>
          </li>
        </router-link>
        <router-link :to="{name:'recommend',query: { supNbr:userInfo.nbr }}">
          <li @click="toColor2">
            <p><img :src="isColor2?require('../assets/images/icon_classification1@2x.png'):require('../assets/images/icon_classification2@2x.png')" alt=""></p>
            <p :class="{bottomBarColorActive:isColor2}">分类</p>
          </li>
        </router-link>
        <router-link @click.native="toColor3" to>
          <li >
            <p><img :src="isColor3?require('../assets/images/icon_gwc1@2x.png'):require('../assets/images/icon_gwc2@2x.png')" alt=""></p>
            <p :class="{bottomBarColorActive:isColor3}">购物车</p>
          </li>
        </router-link>
        <router-link @click.native="toColor4" to>
          <li >
            <p><img :src="isColor4?require('../assets/images/icon_wd1@2x.png'):require('../assets/images/icon_wd2@2x.png')" alt=""></p>
            <p :class="{bottomBarColorActive:isColor4}">我的</p>
          </li>
        </router-link>
      </ul>
    </div>
    <!-- tabbar -->
  </div>
</template>

<script>
  import {mapGetters} from "vuex"

export default {
  name: "Tabbar",
  data() {
    return {
      isColor: false,
      isColor2: false,
      isColor3: false,
      isColor4: false,
      current_tab: "",
      isLogin: false,
    };
  },
  watch:{
    $route(to,form){
      if (to.name == "index") {
        document.title= '有米日记';
        this.isColor = true;
        this.isColor4 = false;
        this.isColor2 = false;
        this.isColor3 = false;
      } else if (to.name == "cart") {
        document.title= '购物车';
        this.isColor4 = false;
        this.isColor2 = false;
        this.isColor = false;
        this.isColor3 = true;
      } else if (to.name == "information") {
        document.title= '个人中心';
        this.isColor4 = true;
        this.isColor3 = false;
        this.isColor2 = false;
        this.isColor = false;
      }else if (to.name == "recommend") {
        document.title= '分类';
        this.isColor2 = true;
        this.isColor3 = false;
        this.isColor4 = false;
        this.isColor = false;
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    toColor: function() {
      this.isColor = true;
      this.isColor2 = false;
      this.isColor4 = false;
      this.isColor3 = false;
    },
    toColor2: function() {
      this.isColor = false;
      this.isColor4 = false;
      this.isColor2 = true;
      this.isColor3 = false;
    },
    toColor3: function() {
      this.$router.push({path:'/cart',query: { supNbr:this.userInfo.nbr }})
      this.isColor4 = false;
      this.isColor = false;
      this.isColor2 = false;
      this.isColor3 = true;
    },
    toColor4: function() {
      this.$router.push({path:'/information',query: { supNbr:this.userInfo.nbr }})
      this.isColor = false;
      this.isColor2 = false;
      this.isColor3 = false;
      this.isColor4 = true;
    }
  },
  mounted() {
    this.current_tab = this.$router.history.current.name;
    var name = this.current_tab;
    if (name == "index") {
      this.isColor = true;
    } else if (name == "recommend") {
      this.isColor2 = true;
    } else if (name == "cart") {
      this.isColor3 = true;
    }else if (name == "information") {
      this.isColor4 = true;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.bottomBar {
  height: .96rem;
  width: 100%;
  bottom: 0;
  background: #fff;
  position: fixed;
  bottom: 0;
  z-index: 100;
  border-top: 1px solid #eeeeee;
}
.bottomBar ul {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-around;
}
.bottomBar ul li {
  width: 1.875rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.bottomBar ul li img {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin: 0 0 0.08rem;
}
.bottomBar ul li p {
  font-family: 400;
  font-size: 0.2rem;
  color: #333;
  letter-spacing: 0;
  line-height: 0.24rem;
}
.bottomBarColorActive {
  color: #E54040 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue